<!-- <div class="dialog-box">
    <h1>Novità!</h1>
    <div mat-dialog-content>
      <p>La nostra agenzia esegue ora anche una particolare tipologia di patente nautica.</p>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button class="default-btn2" style="color: white;" (click)="close()">CLOSE</button>
    </div>
</div> -->


<div class="new-practice-dialog">
  <img src="/assets/img/logo-STeD-by-AgenziaPrincipe.jpg" alt="Logo STeD">
  <h1>NOVITA!</h1>
  <p>L’ AGENZIA PRINCIPE è lieta di comunicarvi che è una delle poche agenzie in Campania ad essere abilitata allo STED!<br>
    Lo STED, Sportello Telematico del Diportista, è ufficialmente il punto di riferimento per chi naviga con unità da diporto in Italia.</p>
  <div mat-dialog-actions>
    <button mat-raised-button class="default-btn2" style="color: white;" (click)="close()">CLOSE</button>
  </div>
</div>
